import React from 'react';
import PropTypes from 'prop-types';

import { FormHelperText as MUIFormHelperText } from '@mui/material';

export const FormHelperText = props => <MUIFormHelperText {...props} />;

FormHelperText.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  filled: PropTypes.bool,
  focused: PropTypes.bool,
  margin: PropTypes.oneOf(['dense']),
  required: PropTypes.bool,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
};

export default FormHelperText;
